
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 170 170","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M85.555-170c43.801.555 83.447 38.184 84.31 83.67.3 47.316.007 124.634.007 171.952-.213 33.591-21.894 65.856-52.801 78.476-33.51 13.683-75.391 2.899-98.195-25.373C7.092 124.114.496 105.661.135 86.702-.165 39.384.128-37.935.128-85.254c.276-43.495 36.958-83.271 82.685-84.72.914-.017 1.828-.028 2.742-.026zM161.528 4.295H8.472c.008 22.434.083 59.866.225 82.298.739 38.763 34.451 73.69 73.353 75.168 40.209 1.528 78.436-32.269 79.253-75.168.142-22.432.217-59.864.225-82.298zM85 99.446l48.317-48.254c1.606-1.071 4.173-.93 5.527.422 1.511 2.012 1.511 4.527 0 6.036l-51.225 51.158c-.754.503-1.721.739-2.674.707-1.127.038-2.195-.338-2.987-1.129L30.734 57.228c-1.073-1.604-.932-4.167.422-5.519 2.015-1.509 4.533-1.509 6.044 0L85 99.446zM161.528-4.295c-.009-22.309-.084-59.619-.225-81.927-.749-39.506-34.744-74.706-75.816-75.226-.491-.002-.982.001-1.473.005-39.298.747-74.534 34.131-75.317 75.217-.141 22.31-.216 59.62-.225 81.931h153.056zM85-99.446L36.683-51.192c-1.606 1.071-4.173.93-5.527-.422-1.511-2.012-1.511-4.527 0-6.036l51.225-51.158c.754-.503 1.721-.739 2.674-.707 1.127-.038 2.195.338 2.987 1.129l51.224 51.158c1.073 1.604.932 4.167-.422 5.519-2.015 1.509-4.533 1.509-6.044 0L85-99.446z","fill-rule":"nonzero"}})])
          )
        }
      }
    